module.exports = __webpack_public_path__ + "img/bg.a8d4572b.jpg";